import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1701115461239,
      object: 'counselors',
      success: true,
      isNew: true,
      eventLink: 'https://www.google.com/calendar/event?eid=dHFoaHZibmQzaXFrdTgwOGowMTNtODY2cmcgc2VydmljZUBjcmVkaXRwcm8uY28uaWw',
    },
    status: 200,
  },

  error: {
    response: {
      createdAt: 1701115461239,
      object: 'counselors',
      success: false,
      isNew: false,
      eventLink: null,
    },
    status: 500,
  },
};

const meetingHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(1000);
  return HttpResponse.json(response, status);
};

export {
  meetingHandler,
};
